import shortid from 'shortid';
import { of } from 'rxjs';
import { map, delay } from 'rxjs/operators';

export function saveStackup(req) {
  const stackup = req.body;
  const source = of(stackup);

  return source.pipe(
    delay(1000),
    map(val => {
      // assign id to each layer;
      const layers = val.layers
        .map(layer => {
          if (layer.id === undefined) {
            return Object.assign({}, layer, { id: shortid.generate() })
          }
          return layer;
        })

      return Object.assign({}, val, { layers });
    }),
    map(val => ({ response: val }))
  )
}

export default saveStackup;



// WEBPACK FOOTER //
// ./src/services/mock.js